import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import { Input, Select } from '../../components/ModalInputs'
import { updateCandidateStatus, getCandidatesList } from '../../actions/candidates'

const candidatesStatuses = [
  { name: 'Подтверждение документов', value: 1 },
  { name: 'Зарегистрировано', value: 2 },
  { name: 'Направлен в класс', value: 3 },
  { name: 'Архивная', value: 4 },
  { name: 'Отказано', value: 5 },
  { name: 'Нет мест', value: 6 },
  { name: 'Зачислен', value: 7 },
]

const StatusModal = ({ open, closeModal, selectedIds, currentFilters }) => {
  const dispatch = useDispatch()
  const [newStatusId, setNewStatusId] = useState('')
  const [orderNumber, setOrderNumber] = useState('')
  const [orderDate, setOrderDate] = useState('')

  const handleSave = async () => {
    if (!newStatusId || !selectedIds.length) return
    for (const id of selectedIds) {
      await dispatch(updateCandidateStatus(id, Number(newStatusId), {
        order_number: orderNumber,
        order_date: orderDate,
      }))
    }
    dispatch(getCandidatesList(currentFilters))
    closeModal()
  }

  return (
    <Modal
      open={open}
      onClose={closeModal}
      showCloseIcon={false}
      classNames={{ modal: styles.statusModal }}
      animationDuration={1}
    >
      <div className={styles.statusModalHeader}>Изменить статус</div>
      <div className={styles.statusModalContent}>
        <Select
          label='Новый статус'
          value={newStatusId}
          onChange={e => setNewStatusId(e.target.value)}
        >
          <option value=''>Выберите...</option>
          {candidatesStatuses.map(s => (
            <option key={s.value} value={s.value}>{s.name}</option>
          ))}
        </Select>
        <Input
          label='Номер приказа'
          value={orderNumber}
          onChange={e => setOrderNumber(e.target.value)}
        />
        <Input
          label='Дата приказа'
          type='date'
          value={orderDate}
          onChange={e => setOrderDate(e.target.value)}
        />
      </div>
      <div className={styles.statusModalFooter}>
        <Button onClick={handleSave} disabled={!newStatusId}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Отмена</Button>
      </div>
    </Modal>
  )
}

export default StatusModal
